<div class="back">
  <!-- Intro -->
  <div class="card card-intro blue-gradient">
    <div class="card-body white-text rgba-black-light text-center">
      <!--Grid row-->
      <div class="row d-flex justify-content-center">
        <!--Grid column-->
        <!-- <div class="col-md-6">
        <div class="btn-group">
        <a href="#" class="btn btn-primary active mr-1" aria-current="page">Complain Register</a>
        <a href="#" class="btn btn-success">Complain status</a>
        </div>
        </div> -->
        <!--Grid row-->
      </div>
    </div>
    <!-- Intro -->
    <section class="testimonial py-5" id="testimonial">
      <div class="container">
        <div class="row ">
          <div class="col-md-4 py-5 bg-success text-white text-center ">
            <div class=" ">
              <div class="card-body">
                <img src="http://www.ansonika.com/mavia/img/registration_bg.svg" style="width:30%">
                <h2 class="py-3">Complain Registration</h2>
                <p>This section is to open a complain in the available category. 
                  Please provide required information to speed up your request.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-8 py-5 border">
            <h4 class="pb-4 text-info">Please fill with your details</h4>
            <form #f="ngForm" (ngSubmit)="createOrUpdatePolicy(f)">
              <div class="form-row"  *ngIf="showMsg" >
                <div class="col-md-12">
                  <p class="alert alert-success">
                    <strong>Complain has been successfully submitted! Your complain Id is: {{complainId}} </strong>
                    <button type = "button" class = "close" data-dismiss = "alert" aria-hidden = "true">
                      &times;
                   </button>
                  </p>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <input id="Full Name" name="name" placeholder="Full Name" class="form-control" type="text" required
                         ngModel>
                </div>
                <div class="form-group col-md-6">
                  <input type="text" class="form-control" id="inputEmail4" name="aadhar" placeholder="Aadhar No."
                         required ngModel>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                <textarea placeholder="Address" id="address" name="address" class="form-control" ngModel>

                </textarea>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <input id="Mobile No." name="phone" placeholder="Mobile No." class="form-control" required="required"
                         type="text" ngModel>
                </div>
                <div class="form-group col-md-6">
                  <select id="inputState" name="subject" placeholder="Choose ..." class="form-control" #mySelect
                          (change)='onOptionsSelected(mySelect.value)' ngModel>
                    <option selected>Choose ...</option>
                    <option>Housing</option>
                    <option>Water</option>
                    <option>PDS</option>
                    <option>Harischandra Sahayata</option>
                    <option>MGNREGA</option>
                    required
                  </select>
                </div>
                <div class="form-check form-check-inline" *ngFor='let scs of subCates;'>
                  <input type="radio" class="form-check-input m-2 text-right" name="sc" value="{{scs}}"
                         (change)="radioChangeHandler($event)" ngModel>
                  <!-- [checked]="item.selected" (change)='radioChecked(item.id,i)'  -->
                  <label class="form-check-label mr-xl-5">{{scs}}</label>
                </div>
                <div class="form-group col-md-12">
<textarea placeholder="Message" id="comment" name="msg" cols="40" rows="5" class="form-control"
          ngModel></textarea>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <div class="form-group">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="invalidCheck2" required>
                      <label class="form-check-label" for="invalidCheck2">
                        <small>By clicking Submit, you agree to our Terms & Conditions, Visitor Agreement and Privacy
                          Policy.</small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <button type="submit" name="submit" class="btn btn-info">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
